import React from 'react';
import { Layout, theme } from 'antd';
import { Container } from './LoginTemplateStyle';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

const LoginTemplate = ({ onSubmit }) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout>
      <Content
        style={{
          background: colorBgContainer,
        }}
      >
        <Container>
          <Outlet />
        </Container>
      </Content>
    </Layout>
  );
};

export default LoginTemplate;
